import React, { memo, useRef, useState, useEffect } from 'react'
import { Box, Flex, Skeleton, Input, InputGroup, Image } from '@chakra-ui/react'
import DsrDisplayTeamAvatar from '../dsr-team-mgmt/DsrDisplayTeamAvatar'
import DsrNavigationDrawerMenu from '../../layout/components/sidebar/components/DsrNavigationDrawerMenu'
import SaveDsrDraftButton from '../dsr-draft/SaveDsrDraftButton'
import { bindActionCreators } from 'redux'
import { withRouter } from 'react-router-dom'
import { connect } from 'react-redux'
import { changeDsrModalState, changeDsrPopupState, setIsReadingMode, updateDsr } from '../actions/dsr-actions'
import { signOut } from '../../auth/actions/auth-actions';

import '../../layout/components/header/styles/header.scss';
import DsrManageOrgLogosModule from '../dsr-draft/DsrManageOrgLogosModule';
import DsrPageSideMenuDrawer from "./DsrPageSideMenuDrawer";
import DsrHeaderMobileDisplay from './DsrHeaderMobileDisplay'
import LaunchdeckTag from '../../global/components/helper-components/components/LaunchdeckTag'
import LaunchdeckButton from '../../global/components/helper-components/components/LaunchdeckButton'
import { DsrPreviewToggleButton } from "../dsr-draft/page-designer/toggle-button/DsrPreviewToggleButton";
import SaveDsrTemplateButton from '../dsr-template/SaveDsrTemplateButton'
import { updateDsrTemplate } from '../actions/dsr-template-actions'
import TemplateHeaderOptionsButton from '../../dashboard/components/vault/TemplateHeaderOptionsButton'
import DsrHeaderMoreOptionsButton from './DsrHeaderMoreOptionsButton'
import { formatDisplayLocalDateTime } from '../helpers/timestamp-display-helper';
import SaveCloseLiveEditButton from '../dsr-draft/SaveCloseLiveEditButton'
import SaveLiveEditDsrButton from '../dsr-draft/SaveLiveEditDsrButton'
import logo from '../../global/styles/images/launchdeck_logo.svg'


// Component holding other authentication components
function DsrHeader({
	isSellingTeamMember,
	isLiveEdit,
	handleViewTeamMembers,
	handleChangeDsrStatus,
	dsrTeamMembers,
	userProfile,
	dsrId,
	dsrPages,
	isEditMode,
	changeDsrPopupState,
	changeDsrModalState,
	handleChangeUserActionRequired,
	orgLogo,
	signOut,
	dsrTitleRedux,
	updateDsr,
	updateDsrTemplate,
	isRoomTemplate,
	// Action,
	setIsReadingMode,
	// Redux
	isMobileView,
	isPagePreviewMode,
	setIsPagePreviewMode,
	dsrPropertiesRedux,
	dsrTemplateId,
	isDsrAdmin,
	isLockedRoom,
	lockedRoomMetadata,
	templateMainContactInfo,
	hideOptionForInvalidLink,
	isReadingMode, 
	restrictPublishAsset
}) {

	const { showGuestList, logoDisplayOption } = dsrPropertiesRedux || {}
	const headerTitleInputRef = useRef(null);
	const [currentDsrTitle, setCurrentDsrTitle] = useState("")
	const [showEditTitleInput, setShowEditTitleInput] = useState(false)
	const [liveLockedRoomMetadata, setLiveLockedRoomMetadata] = useState("")
	const [largeLogoDisplay, setLargeLogoDisplay] = useState(false)
	const showGuestMembers = (showGuestList === undefined || showGuestList) ? true : false


useEffect(() => {
	if (logoDisplayOption === "large-logos" || logoDisplayOption === "nametag") {
		setLargeLogoDisplay(true)
	} else if (logoDisplayOption === "default") {
		setLargeLogoDisplay(false)
	}
},[logoDisplayOption]);

	const handleInputChange = (event) => {
		if (event.target.name === "title") {
			setCurrentDsrTitle(event.target.value)
		}
	}

	const handleHitKey = (event) => {
		if (event.key === "Escape") {
			setShowEditTitleInput(false)
		} else if (event.key === 'Enter') {
			if (event.target.name === "title") {
				clickOutsideAutosave()
			}
		}
	};

	const clickOutsideAutosave = () => {
		setShowEditTitleInput(false)

		if (currentDsrTitle.trim().length > 0) {
			if (isRoomTemplate && dsrTemplateId) {
				updateDsrTemplate({
					sourceEvent: "update-dsr-title",
					dsrTemplateId: dsrTemplateId,
					dsrTitle: currentDsrTitle,
				})
			} else {
				updateDsr({
					dsrId,
					dsrTitle: currentDsrTitle,
					sourceEvent: "update-dsr-title"
				})
			}

		} else (
			setCurrentDsrTitle(dsrTitleRedux ? dsrTitleRedux : "-")
		)
	}

	const handleClickEditInput = (event) => {
		if (headerTitleInputRef.current && !headerTitleInputRef.current.contains(event.target)) {
			clickOutsideAutosave()
		}
	};

	const handleCreateDsrWithTemplate = () => {
		handleChangeUserActionRequired("show-create-dsr-with-template-modal", { dsrTemplateId, dsrTitle: currentDsrTitle })
	}

	const handleUnpublishRoom = () => {
		changeDsrPopupState('revert-dsr-to-draft')
		changeDsrModalState(true)
	}

	// UX listeners
	useEffect(() => {
		document.addEventListener("keydown", handleHitKey, true);
		document.addEventListener("click", handleClickEditInput, true);
		return () => {
			document.removeEventListener("keydown", handleHitKey, true);
			document.removeEventListener("click", handleClickEditInput, true);
		};
	});

	useEffect(() => {
		if (dsrTitleRedux) {
			setCurrentDsrTitle(dsrTitleRedux)
		}
	}, [dsrTitleRedux]);

	useEffect(() => {
		if (lockedRoomMetadata) {
			setLiveLockedRoomMetadata(lockedRoomMetadata)
		}
	}, [lockedRoomMetadata]);


	const renderDsrTitle = () => {

		if (showEditTitleInput) {
			return (
				<Flex fontWeight='600' lineHeight='1.875em' ref={headerTitleInputRef} >
					<InputGroup
						size="2em"
						width="100%"
						maxWidth='35%'
						minWidth='25em'
						border='none'
					>
						<Input
							name="title"
							value={currentDsrTitle}
							onChange={handleInputChange}
							onKeyDown={handleHitKey}
							autoFocus={true}
							// onFocus={e => e.currentTarget.select()}
							fontSize='1.25em'
							border='1px solid'
							borderColor='#3295EC'
							borderRadius='0.25em'
							paddingLeft='5px'
							lineHeight='1.875em'
							fontWeight="600"
						/>

					</InputGroup>
				</Flex>
			)

		} else {
			return (
				<Flex fontWeight='600' fontSize='1.25em' lineHeight='1.875em' justify='flex-start'>
					<Flex
						cursor='pointer'
						border='1px solid'
						borderColor='transparent'
						paddingLeft='5px'
						onClick={() => setShowEditTitleInput(!showEditTitleInput)}
					>
						{currentDsrTitle}
					</Flex>
				</Flex>
			)
		}
	}

	if (hideOptionForInvalidLink) {
		return (
			<>
				<Flex className='dsr-header__section'>
					<Flex className='dsr-header__container' alignItems='center'>
						<Flex justify='flex-start' align='center'>
							<DsrNavigationDrawerMenu userProfile={userProfile} signOut={signOut} darkMode={true} />

							{/* // Logo */}
							<Flex w='100%' justify='flex-start' ml='2em'>
								<Image src={logo} alt="Launchdeck Logo" width='50%' maxWidth='20em' />
							</Flex>

							<Box w={['25%', '25%', '15%', '15%']} my='1.6em' ml='3%'>
							</Box>

						</Flex>

						<Flex>


						</Flex>
					</Flex>
				</Flex>
			</>
		)
	}

	if (isMobileView) {
		return (
			<DsrHeaderMobileDisplay
				isEditMode={isEditMode}
				isSellingTeamMember={isSellingTeamMember}
				currentDsrTitle={currentDsrTitle}
				userProfile={userProfile}
				handleViewTeamMembers={handleViewTeamMembers}
			/>
		)
	}


	// TODO Review refactor logic
	if (isEditMode && typeof isLockedRoom === "boolean" && !isLiveEdit) {
		if (dsrTemplateId) {

			const { currentLockStatus, liveAtTimestamp, lockerUserName } = liveLockedRoomMetadata || {};

			return (
				<>
					<Flex className='dsr-header__section'>
						<Flex className='dsr-header__container' alignItems='center'>
							<Flex justify='flex-start' align='center'>
								<DsrNavigationDrawerMenu userProfile={userProfile} signOut={signOut} darkMode={true} />
								<Box
									className="page-title"
									fontSize={['1em', '1em', '1.25em', '1.25em']} fontWeight='600' lineHeight='1.85em' color='white'
									display='inline-block' ml='2em'>
									Edit Template
								</Box>
								<Box ml='0.5em'>
									{isLockedRoom &&
										<LaunchdeckTag bg='brandPink.500' color='white' label='Locked' reactIcon="lock" />
									}
								</Box>
							</Flex>

							<Flex>
								{!!isLockedRoom ?
									<Flex align='center'>
										<Box color='white' pr={liveAtTimestamp ? '1em' : '7em'}>
											<Box fontSize='0.7em' fontWeight='600'>{currentLockStatus}</Box>
											<Box fontSize='0.6em'>
												<Box>{lockerUserName} </Box>
												{liveAtTimestamp && <Box> Unlocked at: {formatDisplayLocalDateTime(liveAtTimestamp)}</Box>}
											</Box>
										</Box>
										<TemplateHeaderOptionsButton
											handleCreateDsrWithTemplate={handleCreateDsrWithTemplate}
										/>
									</Flex>
									:
									<Flex align='center'>
										<Box mr='1em'>
											<SaveDsrTemplateButton
												dsrTemplateId={dsrTemplateId}
												dsrPages={dsrPages}
											/>
										</Box>
										<Box >
											<TemplateHeaderOptionsButton
												handleCreateDsrWithTemplate={handleCreateDsrWithTemplate}
											/>
										</Box>

									</Flex>
								}
							</Flex>
						</Flex>
					</Flex>

					<Flex justify='center' align='center' bg='brandGreen.500' letterSpacing={'1px'} fontSize='0.8em' color='white' fontWeight='600' py='0.2em'>
						TEMPLATE MODE
					</Flex>
					{isPagePreviewMode
						? (
							<Flex className='dsr-header__section-guest-version'>
								{dsrTitleRedux &&
									<Flex className='dsr-header__container' alignItems='center'>

										<React.Fragment>
											<Flex align='center'>
												<Box mr='1em' />
												<Flex align='center'>
													<Flex mr={templateMainContactInfo?.orgLogo && '1em'}>
														{/* // TODO Refactor: integrate logic into DsrManageOrgLogosModule */}

														{(isRoomTemplate && templateMainContactInfo?.orgLogo) &&
															<Image maxH={'2.5em'} rounded='0.25em' src={templateMainContactInfo.orgLogo} />
														}
														<DsrManageOrgLogosModule logoDisplayMode={logoDisplayOption==="nametag" ? 'nametag' : 'default-dsr'}  isPagePreviewMode={true} logoSize={largeLogoDisplay && '3.5em'} />

													</Flex>
													<Flex fontWeight='600' fontSize='1.25em' lineHeight='1.875em' color='white'>{dsrTitleRedux} </Flex>
												</Flex>
											</Flex>

											<Flex align='center'>
												<Flex>
													<Box><DsrDisplayTeamAvatar perspective='seller' dsrTeamMembers={dsrTeamMembers} /></Box>
													<Box>	{showGuestMembers && <DsrDisplayTeamAvatar perspective='buyer' dsrTeamMembers={dsrTeamMembers} />}</Box>
												</Flex>

												{!isRoomTemplate &&
													<Box rounded='0.25em'>
														<LaunchdeckButton label='Join Room' width='100%' bg='brand.500' color='white'
															onClick={() => {
																changeDsrPopupState("show-preview-page-action-modal")
																changeDsrModalState(true)
															}} />
													</Box>
												}
											</Flex>
										</React.Fragment>
									</Flex>
								}
							</Flex>
						)
						: (
							<>
								{/* <Flex justify='center' align='center' bg='brandGreen.500' letterSpacing={'1px'} fontSize='0.8em' color='white' fontWeight='600' py='0.2em'>
									TEMPLATE MODE
								</Flex> */}
								<Box className='dsr-content__dsr-top-banner'>
									<Flex padding='1em 0' justifyContent='space-between' width='100%'>
										<Flex align='center'>
											<Flex mr='1em'>
												<Flex w='100%' align='center' justify='center'>
													<Box border='2px solid' borderColor='white' rounded='0.5em' bg='white'>
														{orgLogo && <Image maxH={'2.5em'} rounded='0.25em' src={orgLogo} />}
													</Box>
												</Flex>

											</Flex>
											{(currentDsrTitle || showEditTitleInput) ? renderDsrTitle()
												: <Skeleton className="loading-skeleton-bar"><Flex fontSize='1.25em' lineHeight='1.875em' >Sample Text Sample Text Sample Text</Flex></Skeleton>}
										</Flex>
									</Flex>
								</Box>
							</>
						)
					}
				</>
			)
		} else {
			const { currentLockStatus, liveAtTimestamp, lockerUserName } = liveLockedRoomMetadata || {};

			return (
				<>
					<Flex className='dsr-header__section'>
						<Flex className='dsr-header__container' alignItems='center'>
							<Flex justify='flex-start' align='center'>
								<DsrNavigationDrawerMenu userProfile={userProfile} signOut={signOut} darkMode={true} />
								<Box
									className="page-title"
									fontSize={['1em', '1em', '1.25em', '1.25em']} fontWeight='600' lineHeight='1.85em' color='white'
									display='inline-block' ml='2em'>
									Edit Room
								</Box>
								<Box ml='0.5em'>
									{isLockedRoom ?
										<LaunchdeckTag bg='brandPink.500' color='white' label='Draft Locked' reactIcon="lock" />
										:
										<LaunchdeckTag bg='gray.600' color='white' label='Draft' />
									}
								</Box>
							</Flex>
							<Flex>
								<DsrPreviewToggleButton
									offLabelText='Edit'
									onLabelText='Preview'
									isChecked={isPagePreviewMode}
									setIsChecked={setIsPagePreviewMode}
									isLockedRoom={isLockedRoom}
								/>
							</Flex>

							<Flex>

								{!!isLockedRoom ?
									<Box color='white' pr={liveAtTimestamp ? '1em' : '7em'}>
										<Box fontSize='0.7em' fontWeight='600'>{currentLockStatus}</Box>
										<Box fontSize='0.6em'>
											<Box>{lockerUserName} </Box>
											{liveAtTimestamp && <Box> Unlocked at: {formatDisplayLocalDateTime(liveAtTimestamp)}</Box>}
										</Box>
									</Box>
									: isEditMode ?
										<React.Fragment>
											<Flex gap={6} pr='1em'>
												<Box >
													<SaveDsrDraftButton
														dsrId={dsrId}
														dsrPages={dsrPages}
													/>
												</Box>
												<Box >

													<LaunchdeckButton bg='brandGreen.500' color='white' onClick={() => {
														if (restrictPublishAsset) {
															handleChangeUserActionRequired('subscription-nudge',{
																titleText: `⚡ You reached the published Rooms free limit`,
																copyText:"Upgrade to publish unlimited Rooms, get detailed sales intelligence & collaborate with co-workers easily"
															})
														} else if (handleChangeDsrStatus) {
															handleChangeDsrStatus()
														} else {
															changeDsrPopupState('revert-dsr-to-draft')
															changeDsrModalState(true)
														}
													}} label='Publish' />

												</Box>

											</Flex>
										</React.Fragment>
										:
										<Flex alignItems='center'>

											<Box rounded='0.25em'>
												<LaunchdeckButton width='100%' bg='brand.500' color='white' onClick={() => {

													if (handleViewTeamMembers) {
														handleViewTeamMembers()
													} else {
														changeDsrPopupState('view-team-members')
														changeDsrModalState(true)
													}
												}} label='Share' />
											</Box>
										</Flex>
								}
							</Flex>
						</Flex>
					</Flex>
					{isPagePreviewMode
						? (
							<Flex className='dsr-header__section-guest-version'>
								{dsrTitleRedux &&
									<Flex className='dsr-header__container' alignItems='center'>

										<React.Fragment>
											<Flex align='center'>
												<Box mr='1em' />
												<Flex align='center'>
													<Flex mr='1em'>
														<DsrManageOrgLogosModule logoDisplayMode={logoDisplayOption==="nametag" ? 'nametag' : 'default-dsr'}  isPagePreviewMode={true} logoSize={largeLogoDisplay && '3.5em'} />
													</Flex>
													<Flex fontWeight='600' fontSize='1.25em' lineHeight='1.875em' color='white'>{dsrTitleRedux} </Flex>
												</Flex>
											</Flex>

											<Flex align='center'>
												<Flex>
													<Box><DsrDisplayTeamAvatar perspective='seller' dsrTeamMembers={dsrTeamMembers} /></Box>
													<Box>	{showGuestMembers && <DsrDisplayTeamAvatar perspective='buyer' dsrTeamMembers={dsrTeamMembers} />}</Box>
												</Flex>

												<Box rounded='0.25em'>
													<LaunchdeckButton label='Join Room' width='100%' bg='brand.500' color='white'
														onClick={() => {
															changeDsrPopupState("show-preview-page-action-modal")
															changeDsrModalState(true)
														}} />
												</Box>
											</Flex>
										</React.Fragment>
									</Flex>
								}
							</Flex>
						)
						: (
							<Flex className='dsr-content__dsr-top-banner'>
								<Flex padding='1em 0' justifyContent='space-between' width='100%'>
									<Flex align='center'>
										<Flex mr='1em'>
											<DsrManageOrgLogosModule logoDisplayMode={logoDisplayOption==="nametag" ? 'nametag' : 'default-dsr'}  isPagePreviewMode={false} logoSize={largeLogoDisplay && '3.5em'} />
										</Flex>
										{(currentDsrTitle || showEditTitleInput) ? renderDsrTitle()
											: <Skeleton className="loading-skeleton-bar"><Flex fontSize='1.25em' lineHeight='1.875em' >Sample Text Sample Text Sample Text</Flex></Skeleton>}
									</Flex>

									<Flex>
										<Flex justify='center' align='center'>
											<Box><DsrDisplayTeamAvatar perspective='seller' dsrTeamMembers={dsrTeamMembers} /></Box>
											<Box>
												{showGuestMembers && <DsrDisplayTeamAvatar perspective='buyer' dsrTeamMembers={dsrTeamMembers} />}
											</Box>
										</Flex>
										<Box display='flex' alignItems='center' justifyContent='center'>
											<Box px='1em'>

												<LaunchdeckButton label='Manage Access' fontSize='0.8em' py='0.4em' px='1em' bg='brand.500' color='white'
													onClick={() => {

														if (handleViewTeamMembers) {
															handleViewTeamMembers()
														} else {
															changeDsrPopupState('view-team-members')
															changeDsrModalState(true)
														}
													}} />
											</Box>
										</Box>
									</Flex>
								</Flex>
							</Flex>
						)
					}
				</>
			);
		}


	} else if (isLiveEdit) {
		return (
			<>
				<Flex className='dsr-header__section'>
					<Flex className='dsr-header__container' alignItems='center'>
						<Flex justify='flex-start' align='center'>
							<DsrNavigationDrawerMenu userProfile={userProfile} signOut={signOut} darkMode={true} />
							<Box
								className="page-title"
								fontSize={['1em', '1em', '1.25em', '1.25em']} fontWeight='600' lineHeight='1.85em' color='white'
								display='inline-block' ml='2em'>
								Manage Room
							</Box>
							<Box ml='0.5em'>
								<LaunchdeckTag bg='brandPink.500' color='white' label='Edit Mode' />
							</Box>
						</Flex>

						<Flex>


							<React.Fragment>
								<Flex align='center' gap={6}>

									{/* <Box rounded='0.25em'>
										<LaunchdeckButton width='100%' bg='brand.500' color='white' onClick={() => {

											if (handleViewTeamMembers) {
												handleViewTeamMembers()
											} else {
												changeDsrPopupState('view-team-members')
												changeDsrModalState(true)
											}
										}} label='Share' />
									</Box> */}

									{isDsrAdmin && <>
										<SaveLiveEditDsrButton
											dsrId={dsrId}
											dsrPages={dsrPages}
										/>

										<SaveCloseLiveEditButton
											dsrId={dsrId}
											dsrPages={dsrPages}
										/>
									</>
									}

								</Flex>
							</React.Fragment>

						</Flex>
					</Flex>
				</Flex>

				<Flex className='dsr-content__dsr-top-banner'>
					<Box display={['flex', 'flex', 'none', 'none']}>
						<DsrPageSideMenuDrawer />
					</Box>
					<Flex flexDirection={['column', 'row', 'row', 'row']} justifyContent='space-between' width='100%' alignItems='center' p={['0 1em', '1em', '1em', '1em']}>
						<Flex flexDirection={['column', 'row', 'row', 'row']} alignItems='center' >
							<Flex mr='1em'>
						
								<DsrManageOrgLogosModule logoDisplayMode={logoDisplayOption==="nametag" ? 'nametag' : 'default-dsr'} isLiveEdit={isLiveEdit} logoSize={largeLogoDisplay && '3.5em'} />
	
							</Flex>
							{(currentDsrTitle || showEditTitleInput)
								? renderDsrTitle()
								: <Skeleton className="loading-skeleton-bar"><Flex fontSize='1.25em' lineHeight='1.875em' rounded='0.25em'>Sample Text Sample Text Sample Text</Flex></Skeleton>}
						</Flex>

						<Flex>
							<Flex>
								<Box><DsrDisplayTeamAvatar perspective='seller' dsrTeamMembers={dsrTeamMembers} /></Box>
								<Box>	{showGuestMembers &&
									<DsrDisplayTeamAvatar perspective='buyer' dsrTeamMembers={dsrTeamMembers} />
								}</Box>
							</Flex>
						</Flex>
					</Flex>
				</Flex>
			</>
		);
	} else {

		if (isSellingTeamMember === true) {
			return (
				<>
					<Flex className='dsr-header__section'>
						<Flex className='dsr-header__container' alignItems='center'>
							<Flex justify='flex-start' align='center'>
								<DsrNavigationDrawerMenu userProfile={userProfile} signOut={signOut} darkMode={true} />
								<Box
									className="page-title"
									fontSize={['1em', '1em', '1.25em', '1.25em']} fontWeight='600' lineHeight='1.85em' color='white'
									display='inline-block' ml='2em'>
									Manage Room
								</Box>
								<Box ml='0.5em'>
									<LaunchdeckTag bg='green.500' color='white' label='Active' />
								</Box>
							</Flex>

							<Flex>


								<React.Fragment>
									<Flex align='center' gap={6}>
										<Box rounded='0.25em'>
											<LaunchdeckButton width='100%' bg='brand.500' color='white' onClick={() => {
												if (handleViewTeamMembers) {
													handleViewTeamMembers()
												} else {
													changeDsrPopupState('view-team-members')
													changeDsrModalState(true)
												}
											}} label='Share' />
										</Box>

										<DsrHeaderMoreOptionsButton
											handleUnpublishRoom={handleUnpublishRoom}
											setIsReadingMode={setIsReadingMode}
											isReadingMode={isReadingMode}
											dsrId={dsrId}
											isDsrAdmin={isDsrAdmin}
											isLockedRoom={isLockedRoom}
											lockedRoomMetadata={lockedRoomMetadata}
										/>

									</Flex>
								</React.Fragment>

							</Flex>
						</Flex>
					</Flex>

					<Flex className='dsr-content__dsr-top-banner'>
						<Box display={['flex', 'flex', 'none', 'none']}>
							<DsrPageSideMenuDrawer />
						</Box>
						<Flex flexDirection={['column', 'row', 'row', 'row']} justifyContent='space-between' width='100%' alignItems='center' p={['0 1em', '1em', '1em', '1em']}>
							<Flex flexDirection={['column', 'row', 'row', 'row']} alignItems='center' >
								<Flex mr='1em'>
									<DsrManageOrgLogosModule logoDisplayMode={logoDisplayOption==="nametag" ? 'nametag' : 'default-dsr'}  isPagePreviewMode={isPagePreviewMode} logoSize={largeLogoDisplay && '3.5em'}  />
								</Flex>
								{currentDsrTitle ?
									<Flex fontWeight='600' fontSize='1.25em' lineHeight='1.875em' justify='flex-start' textAlign='center'>
										{currentDsrTitle}
									</Flex>
									: <Skeleton className="loading-skeleton-bar"><Flex fontSize='1.25em' lineHeight='1.875em' rounded='0.25em'>Sample Text Sample Text Sample Text</Flex></Skeleton>}
							</Flex>

							<Flex>
								<Flex>
									<Box><DsrDisplayTeamAvatar perspective='seller' dsrTeamMembers={dsrTeamMembers} /></Box>
									<Box>	{showGuestMembers &&
										<DsrDisplayTeamAvatar perspective='buyer' dsrTeamMembers={dsrTeamMembers} />
									}</Box>
								</Flex>
							</Flex>
						</Flex>
					</Flex>
				</>
			);
		} else {
			return (
				<>
					<Flex className='dsr-header__section-guest-version'>
						<Flex className='dsr-header__container' alignItems='center'>
							<Flex align='center'>
								{/* // TODO: A design solution is needed for a mobile view drawer to let users choose DSR pages & to go back to Vault (just one option to home page) */}
								<Box mr='1em'>
									<DsrNavigationDrawerMenu userProfile={userProfile} signOut={signOut} darkMode={true} />
								</Box>

								{dsrTitleRedux ?
									<Flex align='center'>
										<Flex mr='1em'>
											<DsrManageOrgLogosModule logoDisplayMode={logoDisplayOption==="nametag" ? 'nametag' : 'default-dsr'}  isPagePreviewMode={isPagePreviewMode} logoSize={largeLogoDisplay && '3.5em'} />
										</Flex>
										<Flex fontWeight='600' fontSize='1.25em' lineHeight='1.875em' color='white'>{dsrTitleRedux} </Flex>
									</Flex>
									: <Skeleton className="loading-skeleton-bar"><Flex fontSize='1.25em' lineHeight='1.875em'>Sample Text Sample Text Sample Text</Flex></Skeleton>}
							</Flex>

							<Flex align='center'>
								<Flex>
									<Box><DsrDisplayTeamAvatar perspective='seller' dsrTeamMembers={dsrTeamMembers} /></Box>
									<Box>	{showGuestMembers && <DsrDisplayTeamAvatar perspective='buyer' dsrTeamMembers={dsrTeamMembers} />}</Box>
								</Flex>

								{/* // Display only after loading & setting states are completed */}
								{dsrTitleRedux &&
									<LaunchdeckButton noHover bg='brand.500' color='white' onClick={() => {
										if (handleViewTeamMembers) {
											handleViewTeamMembers()
										} else {
											changeDsrPopupState('view-team-members')
											changeDsrModalState(true)
										}
									}} label='Invite members' />
								}
							</Flex>
						</Flex>
					</Flex>
				</>
			);
		}
	}

}

const mapStateToProps = (state) => ({
	dsrTitleRedux: state.dsrTitle.title,
	dsrPropertiesRedux: state.draftDsrProperties.properties,
	isMobileView: state.mobileViewMode.isMobileView,
	dsrTemplateId: state.dsrTemplateId.results,
	isRoomTemplate: state.dsrTemplateId.isRoomTemplate,
	isDsrAdmin: state.dsrAdmin.isDsrAdmin,
	isLockedRoom: state.lockedRoomCheck.isLockedRoom,
	lockedRoomMetadata: state.lockedRoomMetadata.results,
	templateMainContactInfo: state.dsrTemplateMainContact.results,
	isReadingMode: state.isReadingMode.results,
	restrictPublishAsset: state.restrictPublishAsset.results
})



const mapDispatchToProps = (dispatch) =>
	bindActionCreators(
		{
			updateDsr,
			updateDsrTemplate,
			setIsReadingMode,
			changeDsrPopupState,
			changeDsrModalState,
			signOut
		},
		dispatch,
	)

export default memo(withRouter(connect(mapStateToProps, mapDispatchToProps)(DsrHeader)))

